import { removeClass } from 'common/tools/dom/classes';
import request from 'common/tools/network/request';
import { path } from 'common/tools/network/routing';
import { desobfuscateUrl } from 'common/tools/seo/desobfuscation';
import trans from 'common/tools/translations/trans';

const msgBox = document.getElementById('msg-box');
const commonErrorMsg = trans('error_text');

export default function () {
  const encodedParamsUrl = document.location.hash.split('#')[1];

  if (!encodedParamsUrl) {
    goHome();
    return false;
  }

  const params = getJsonFromParams(encodedParamsUrl);
  const type = params['data-affiliation-type'];

  switch (type) {
    case 'svod':
      handleSvodAffiliation(params);
      break;
    case 'standalone':
      handleStandAloneAffiliation(params);
      break;
    case 'product':
    case 'vod':
      handleProductAffiliation(params);
      break;
    case 'c2c-product':
      handleC2CProductAffiliation(params);
      break;
    case 'c2c-link':
      handleC2CLink(params);
      break;
    default:
      goHome();
  }
}

async function handleSvodAffiliation(params) {
  const entityId = params['data-entity-id'];
  const entityType = params['data-entity-type'] || null;
  const provider = params['data-provider'];
  const uniqueUrlType = params['data-unique-url-type'] || null;
  const urlMedia = params['data-url-media'] || null;
  const usePrefix = params['data-prefix'];
  const utm = params['data-utm']
    ? decodeURIComponent(params['data-utm'])
    : null;

  try {
    const data = await request(path('affiliate_svod_jump'), {
      method: 'POST',
      payload: {
        id: entityId,
        type: entityType,
        provider: provider,
        uniqueUrlType: uniqueUrlType,
        urlMedia: urlMedia,
        usePrefix: usePrefix,
        utm: utm
      },
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (data.url) {
      goDestination(data.url);
    } else {
      showErrorMsg('Svod link request ok but no url retrived');
    }
  } catch (e) {
    showErrorMsg('Svod link request error');
  }
}

function handleStandAloneAffiliation(params) {
  const affiliationLink = decodeURIComponent(params['data-destination']);

  if (!affiliationLink) {
    goHome();
  }

  const link = window.atob(affiliationLink);
  goDestination(link, 1000);
}

function handleProductAffiliation(params) {
  const affiliationLink = decodeURIComponent(params['data-destination']);
  if (!affiliationLink) {
    goHome();
  }

  const link = desobfuscateUrl(affiliationLink);
  goDestination(link);
}

function handleC2CLink(params) {
  const affiliationLink = decodeURIComponent(params['data-destination']);

  if (!affiliationLink) {
    goHome();
  }

  const link = desobfuscateUrl(affiliationLink);
  goDestination(link);
}

function handleC2CProductAffiliation(params) {
  const affiliationLink = decodeURIComponent(params['data-destination']);

  if (!affiliationLink) {
    goHome();
  }

  const link = desobfuscateUrl(affiliationLink);

  let xhr = new XMLHttpRequest();

  xhr.onload = function () {
    const url = JSON.parse(xhr.response).url;
    goDestination(url);
  };
  xhr.open('POST', path('generate_jump_link'), true);

  xhr.send(
    JSON.stringify({
      url: link,
      partner: params['data-merchant-company-name'],
      productName: decodeURIComponent(params['data-product-name']),
      parentEntityId: params['data-entity-id'],
      type: params['data-affiliation-type']
    })
  );
}

function goHome() {
  window.location.href = path('homepage');
}

function goDestination(url, timeout = 0) {
  setTimeout(() => {
    window.location.href = url;
  }, timeout);
}

function showErrorMsg(log) {
  if (log) {
    // eslint-disable-next-line no-console
    console.warn(log);
  }

  if (!msgBox) {
    return false;
  }

  removeClass(msgBox, 'loading');

  const message = document.createTextNode(commonErrorMsg);
  msgBox.appendChild(message);
}

function getJsonFromParams(encodedParams) {
  const paramsArray = decodeURI(encodedParams).replace(/"/g, '\\"').split('&');
  const paramObj = {};

  paramsArray.forEach(item => {
    const key = item.split('=')[0];
    paramObj[key] = item.split(`${key}=`)[1];
  });

  return paramObj;
}
